import { render } from "./BusIconRTPI.vue?vue&type=template&id=0cbdf560"
const script = {}
script.render = render

export default script